import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Form from "./Form";

export function SendModal({ purchaseOrder, visible, close, invoiceToIre }) {
  return (
    <Modal open={visible} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Are You Sure?</h4>
      </Header>
      <Form
        close={close}
        purchaseOrderId={purchaseOrder.get("id")}
        invoiceToIre={invoiceToIre}
      />
    </Modal>
  );
}

SendModal.propTypes = {
  purchaseOrder: T.instanceOf(Map).isRequired,
  visible: T.func.isRequired,
  close: T.func.isRequired,
  invoiceToIre: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/Send/SendModal.jsx